<template>
  <v-dialog v-model="dialog.display" max-width="550px">
    <v-card>
      <v-card-title>
        <span class="text-subtitle-2">
          <span class="font-weight-bold secondary-font">{{
            $t("subscriptions.details.title")
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-3 pt-4">
        <v-container fluid grid-list-md v-if="!_.isEmpty(subscription)">
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-calendar-blank-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("commons.fields.created.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    $moment(subscription.created).format("YYYY-MM-DD HH:mm:ss")
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <template v-if="$auth.check(['ROLE_ADMIN'])">
            <v-divider></v-divider>
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="8" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-account-outline</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("commons.fields.account.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2">{{
                      $objectPath.get(subscription, "application.user.username")
                    }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </template>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-api</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("subscriptions.fields.api.version")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span
                    class="text-body-2"
                    v-if="
                      $objectPath.get(subscription, 'data.dto.callback_url')
                    "
                    >{{
                      $t("commons.fields.version.number", { version: 2 })
                    }}</span
                  ><span v-else>{{
                    $t("commons.fields.version.number", { version: 1 })
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="3" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-identifier</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("subscriptions.fields.identifier.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="9" class="py-2">
              <div class="text-right">
                <span class="text-body-2">{{ subscription.identifier }}</span>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1"
                  >mdi-credit-card-multiple-outline</v-icon
                >
                <span class="text-body-1 font-weight-bold">{{
                  $t("cga.fields.subscription_type.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    $t(`cga.fields.subscription_type.${subscription.type}`)
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-clipboard-account-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("subscriber.fields.account_number.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    subscription.account_number
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-archive-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("cga.fields.pack.title2")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    $objectPath.get(subscription, "pack.label")
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <template v-if="subscription.pack_options.length">
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="4" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1"
                    >mdi-archive-arrow-up-outline</v-icon
                  >
                  <span class="text-body-1 font-weight-bold">{{
                    $t("cga.fields.pack_options.title2")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="8" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2">{{
                      getLabelPackOptions(subscription.pack_options)
                    }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </template>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-archive-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("cga.fields.duration.title2")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2"
                    >{{ subscription.duration }}
                    {{ $t("commons.months") }}</span
                  >
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-cash</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("subscriptions.fields.amount.cga")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">
                    {{ $utils.numberformat(subscription.amount, lang) }}</span
                  >
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-radiobox-blank</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("subscriptions.fields.status.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip
                  class="table-chips text-body-2"
                  color="success"
                  v-if="subscription.status === 'SUCCESS'"
                >
                  <span>{{
                    $t(`subscriptions.fields.status.${subscription.status}`)
                  }}</span>
                </v-chip>
                <v-chip
                  class="table-chips text-body-2"
                  color="primary"
                  v-else-if="
                    subscription.status === 'PENDING' ||
                      subscription.status === 'IN_PROGRESS'
                  "
                >
                  <span>{{
                    $t(`subscriptions.fields.status.${item.status}`)
                  }}</span>
                </v-chip>
                <v-chip class="table-chips text-body-2" color="error" v-else>
                  <span>{{
                    $t(`subscriptions.fields.status.${subscription.status}`)
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <template v-if="subscription.errors.length">
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="3" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-alert-circle-outline</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("commons.fields.errors.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="9" class="py-2">
                <div class="text-right">
                  <span class="text-body-2">{{
                    subscription.errors.join(", ")
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </template>
          <template
            v-if="
              notification &&
                $objectPath.get(subscription, 'data.dto.callback_url')
            "
          >
            <v-divider></v-divider>
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="8" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-archive-outline</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("subscriptions.fields.amount.paid")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2"
                      >{{
                        $utils.numberformat(
                          subscription.data.dto.amount_paid,
                          lang
                        )
                      }}
                    </span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="8" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-bell-outline</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("subscriptions.fields.notification.received")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <div class="text-right">
                  <v-chip
                    class="table-chips text-body-2"
                    color="success"
                    v-if="notification.received"
                  >
                    <span>{{ $t("btn.yes") }}</span>
                  </v-chip>
                  <v-chip class="table-chips text-body-2" color="error" v-else>
                    <span>{{ $t("btn.no") }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  created() {
    this.lang = this.$utils.setLocaleToBCP47(this.$i18n.locale);
  },
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          display: false,
        };
      },
    },
    subscription: {
      default: function() {
        return {};
      },
    },
  },
  data: () => ({
    lang: null,
    loading: {
      notification: false,
    },
    notification: null,
  }),
  watch: {
    async "dialog.display"(val) {
      if (!val) {
        this.notification = null;
      }

      this.notification = await this.getNotification();
    },
  },
  methods: {
    getLabelPackOptions(pack_options) {
      return pack_options.map((po) => `${po.label} - ${po.price}`).join(", ");
    },
    async getNotification() {
      let notification = null;
      this.loading.notification = true;
      try {
        const response = await this.request({
          url: `api/notifications/${this.subscription.id}/subscription`,
        });
        notification = response.data;
      } catch (error) {
        notification = null;
      }
      this.loading.notification = false;

      return notification;
    },
    ...mapActions({ request: "request" }),
  },
};
</script>
